import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=04ad8f5f"
import script from "./FieldSelector.vue?vue&type=script&lang=js"
export * from "./FieldSelector.vue?vue&type=script&lang=js"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=04ad8f5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports